export const thStyle = (dark) => ({
  padding: '10px 12px',
  textAlign: 'left',
  fontSize: 11,
  fontWeight: 600,
  color: dark ? '#94A3B8' : '#64748B',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  whiteSpace: 'nowrap',
  position: 'sticky',
  top: 0,
});

export const tdStyle = (dark) => ({
  padding: '10px 12px',
  color: dark ? '#CBD5E1' : '#334155',
  whiteSpace: 'nowrap',
});

export const iconBtnStyle = (dark) => ({
  padding: 6,
  borderRadius: 6,
  border: `1px solid ${dark ? '#475569' : '#E2E8F0'}`,
  background: 'transparent',
  cursor: 'pointer',
  color: dark ? '#94A3B8' : '#475569',
  display: 'flex',
});
